import {RightMenuName, RootStore} from "./RootStore"
import {UserSessionState} from "@stores/UserSessionState";
import {DataSourceManager} from "@stores/dataSources/DataSourceManager";
import {ModalEntry} from "@stores/ModalController";
import {RouterService} from "../navigation/RouterService";
import {ServiceRegistry} from "../platform/ServiceRegistry";

export interface RootStoreEnv {
    toggleIsTreeCollapsed: (newValue?: boolean) => void,
    setRightMenu: (rightMenu: RightMenuName) => void,
    setModal: (entry: ModalEntry | null) => void,
    getUserState: () => UserSessionState | undefined,
    getDsManager: () => DataSourceManager | undefined,
    routerService: () => RouterService,
    getServiceRegistry: () => ServiceRegistry,
}

export const createRootStore = (envRootStoreEnv: RootStoreEnv) => RootStore.create(
    {
        darkTheme: false
    },
    envRootStoreEnv
);
